import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text" }
const _hoisted_2 = ["src"]

import { computed, ref, inject} from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'StudiesSwiper',
  setup(__props) {

const store: any = inject(`store`);
const router: any = inject(`router`);
const displayWidth: any = inject(`displayWidth`);
const swipper = ref();
const elementsArray = store.getters.getSwipperElementsArray;

const computedDisplayWidth = computed(() => {
  return displayWidth.value < 700;
});
const clicked = ref(false);
let swipperMoved = computedDisplayWidth.value?displayWidth.value / 2 -556.5:0;
let clientX = 0;
let swipperOffset = 0

function swipe(event: TouchEvent) {
  if (computedDisplayWidth.value) {
    clientX = clientX || event.targetTouches[0].clientX*2;
    swipperOffset = swipperMoved + ((event.targetTouches[0].clientX*2) - clientX);
    swipper.value.style.transform = `translateX(${swipperOffset}px)`;
  }
}

function transition(transitionValue: number, to: boolean) {
  if (!swipper.value || Math.abs(transitionValue) < 5 || clicked.value) {
    return;
  }
  let newSwiperOffset = transitionValue - transitionValue * 0.9;
  to ? (swipperOffset -= newSwiperOffset) : (swipperOffset += newSwiperOffset);
  swipper.value.style.transform = `translateX(${swipperOffset}px)`;
  swipperMoved = +swipper.value.style.transform.slice(11, -3);
  setTimeout(() => transition(transitionValue * 0.9, to), 10);
}

function touchEnd() {
  clientX = 0;
  clicked.value = false;
  swipperMoved = +swipper.value.style.transform.slice(11, -3);
  if (swipperOffset >= displayWidth.value - 50 || swipperOffset <= -1055) {
    transition(
      Math.abs(
        swipperOffset -
          (swipperOffset > 0 ? -4 : -1085 + (displayWidth.value - 14))
      ),
      swipperOffset >= displayWidth.value - 50
    );
  }
}

return (_ctx: any,_cache: any) => {
  const _component_SectionHeader = _resolveComponent("SectionHeader")!
  const _component_BaseAnchor = _resolveComponent("BaseAnchor")!
  const _component_BaseCard = _resolveComponent("BaseCard")!

  return (_openBlock(), _createElementBlock("section", {
    onTouchmove: swipe,
    onTouchstart: _cache[0] || (_cache[0] = ($event: any) => (clicked.value = true)),
    onTouchend: touchEnd
  }, [
    _createVNode(_component_SectionHeader, {
      title: "Case Studies",
      id: "cases",
      text: "Explore Real-Life Examples of Our Proven Digital Marketing Success through Our Case Studies"
    }),
    _createElementVNode("div", {
      class: _normalizeClass([
        `cardsContainer`,
        { cardsContainerDesktop: !computedDisplayWidth.value },
      ]),
      ref_key: "swipper",
      ref: swipper
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(elementsArray), (element) => {
        return (_openBlock(), _createBlock(_component_BaseCard, {
          class: "card",
          key: element,
          styleProp: "black"
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_1, _toDisplayString(element.text), 1),
            _createVNode(_component_BaseAnchor, {
              theme: "green",
              onClick: ($event: any) => (
            _unref(router).push({ path: element.to, query: { name: element.theme } })
          ),
              class: "anchor"
            }, {
              default: _withCtx(() => [
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "learnMore" }, "Learn More", -1)),
                _createElementVNode("img", {
                  src: require(`../assets/blackArrowButton.png`),
                  alt: ""
                }, null, 8, _hoisted_2)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ], 2)
  ], 32))
}
}

})